import type {
  CreateNurseInput,
  NurseWithContactRelations,
  Team,
  UpdateNurseInput,
} from "dutyon-server/types";
import { httpClient } from "./httpClient";

export type { CreateNurseInput, UpdateNurseInput } from "dutyon-server/types";

export const createNurse = (data: CreateNurseInput) => {
  return httpClient.post("/nurses", data).then((res) => res.data);
};

export type NurseWithRelations = NurseWithContactRelations & { team: Team | null };

export const findAllNurses = (params?: {
  teamId?: string;
  companyId?: string;
  email?: string;
  page?: number;
  limit?: number;
}): Promise<{ list: NurseWithRelations[]; total: number }> => {
  return httpClient
    .get<{ list: NurseWithRelations[]; total: number }>("/nurses", { params })
    .then((res) => res.data);
};

export const findOneNurse = (params: { id: string }): Promise<NurseWithRelations> => {
  return httpClient.get<NurseWithRelations>(`/nurses/${params.id}`).then((res) => res.data);
};

export const updateNurse = (params: { id: string; data: UpdateNurseInput }) => {
  return httpClient.patch(`/nurses/${params.id}`, params.data).then((res) => res.data);
};

export const removeNurse = (params: { id: string }) => {
  return httpClient.delete(`/nurses/${params.id}`).then((res) => res.data);
};
